












import Vue from 'vue'
import Component from 'vue-class-component'
import { IWizardStepEmailNotification } from '@app/componentlib/common/types/WizardTypes';
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch';
import ButtonWithCheckMark from '../../components/ButtonWithCheckMark.vue';
import { AppModule } from '@app/componentlib/src/store/modules/app';

@Component<WizardStepJobMatchEmailNotification>({
  props: {
    wizardstep: Object
  },
  components: {
    ButtonWithCheckMark
  }
})

export default class WizardStepJobMatchEmailNotification extends Vue {
  /**
   * Props variables
   */

  wizardstep: IWizardStepEmailNotification | undefined

  /**
   * Component state variables
   */

   notificationLevel: string = ""
   email: string = ""

  /**
   * Lifecycle
   */
  mounted() {
    this.email = JobMatchModule.userInfo?.email ?? ""

    if(this.email === "") {
      this.notificationLevel = "NoNotification"
      this.setNotificationLevel("NoNotification")
    } else if(JobMatchModule.jobMatchProfile.notificationSettings !== undefined) {
      let frequency = JobMatchModule.jobMatchProfile.notificationSettings?.emailNotificationsFrequency
      if (frequency == null) {
        this.setNotificationLevel('TwiceWeekly')
      } else {
        this.notificationLevel = JobMatchModule.jobMatchProfile.notificationSettings?.emailNotificationsFrequency
      }
    }
  }

  /**
   * Getters
   */

   get isMobile (): boolean {
    return AppModule.isMobile
   }


  /**
   * Methods
   */

   setNotificationLevel(level: string) {
    this.notificationLevel = level

    var profile = JobMatchModule.jobMatchProfile

    var enableEmailNotification = true

    if(level === "NoNotification") {
      enableEmailNotification = false
    }

    profile.notificationSettings = {
      enableEmailNotifications: enableEmailNotification,
      emailNotificationsFrequency: level,
      bu: JobMatchModule.userInfo?.businessUnit
    }

    JobMatchModule.updateJobMatchProfile(profile)
   }

   generateInfoBox() {
    var email = JobMatchModule.userInfo?.email ?? ""

    if(email !== "") {
      return this.wizardstep?.infoBox.replace('<p>', '').replace('</p>', '').replace('{{email}}','<strong>'+email+'</strong>')
    } else {
      return this.wizardstep?.infoBoxNoEmail.replace('<p>', '').replace('</p>', '')
    }
   }

}
